<template>
  <div class="waypoint">
    <div v-if="last_waypoint">
      <div class="departure_time">
      {{arrivalTime}}</div>
      <div class="circle"></div>
      <div class="location"><b>{{destinationName}}</b></div>
    </div>
    <div v-else>
      <div class="departure_time">
      {{departureTime}}</div>
      <div class="circle"></div>
      <div class="location"><b>{{originName}}</b></div>
    </div>

    
  </div>
  

</template>

<script>
import Vuetify from 'vuetify';
import LegIcon from './LegIcon.vue'
import moment from 'moment';


export default {
  components: {
      LegIcon,
  },
  props: ['leg', 'last_waypoint'],
  data() {
    return {
      test: ""
    }
  },
  computed: {
    departureTime: function() {
      return moment(this.leg.aimedStartTime).format('HH:mm');
    },
    arrivalTime: function() {
      return moment(this.leg.aimedEndTime).format('HH:mm');
    },
    originName: function() {
      if (this.leg.fromPlace.name == 'Origin') {
        return "Start";
      }
      return this.leg.fromPlace.name;
    },
    destinationName: function() {
      if (this.leg.toPlace.name == 'Destination') {
        return "Bestemming";
      }
      return this.leg.toPlace.name;

    },
  },
};

</script>
<style scoped>
div {
  vertical-align: top;
  display: inline-block;
}
.departure_time {
  width: 50px;
  text-align: right;
  padding-right: 10px;
  vertical-align: bottom;
  margin-left: 5px;
}

.waypoint {
  padding: 8px;
  height: 85px;
}
.circle {
  border-radius: 10px;
  position: relative;
  top: 6px;
  left: 14px;
  height: 20px;
  width: 20px;
  border: 2px solid #f1670c;
  z-index: 11;
}

.location {
  overflow: hidden;
  width:150px;
  margin-left: 20px;
}




</style>